import type { LabelHTMLAttributes } from 'react'
import { cn } from '@/components/ui/cn'

export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn('text-sm font-medium text-foreground', className)} {...props} />
}
